<template>
    <VModalWrapper :title="title" v-on="listeners" v-bind="attributes">
        <ValidationObserver v-slot="{ handleSubmit }">
            <form class="active-form" @submit.prevent="handleSubmit(submit)">
                <ValidationProvider class="active-form__field" name="priority" rules="required" v-slot="{ errors }">
                    <label class="active-form__label active-form__label_required" for="request-priority"
                        >Приоритет</label
                    >

                    <VSelect
                        id="request-priority"
                        name="priority"
                        label="title"
                        class="active-form__control"
                        :class="{
                            error: errors[0],
                        }"
                        :clearable="false"
                        :searchable="false"
                        :reduce="(x) => x.value"
                        :options="options"
                        v-model="priority"
                    ></VSelect>

                    <span class="active-form__error">
                        {{ errors[0] }}
                    </span>
                </ValidationProvider>

                <div class="active-form__actions">
                    <VButton type="button" class="active-form__action button_green-light" @click="hide">
                        Отмена
                    </VButton>

                    <VButton type="submit" class="active-form__action button_green"> Изменить </VButton>
                </div>
            </form>
        </ValidationObserver>
    </VModalWrapper>
</template>
<script>
// Components
import VSelect from '../components/VSelect/VSelect.vue';
import VButton from '../components/VButton/VButton.vue';
import VModalWrapper from '../components/VModalWrapper/VModalWrapper.vue';

import { ValidationObserver, ValidationProvider } from 'vee-validate';

// Other
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ModalNames from '../../js/enums/ModalNames';
import ModalMixin from '../../js/vue/mixins/ModalMixin';
import { priorityOptions } from '../../js/requestPriority';

/**
 * Ручная смена приоритета обращения. Меняется только это обращение: связанные с ним
 * (массовая проблема) остаются со своими приоритетами.
 */
@Component({
    components: {
        VSelect,
        VButton,
        VModalWrapper,

        ValidationObserver,
        ValidationProvider,
    },
})
class VRequestChangePriorityModal extends ModalMixin {
    @Prop({ type: String, default: ModalNames.REQUEST_CHANGE_PRIORITY })
    name;
    @Prop({ type: String, default: 'Приоритет обращения' })
    defaultTitle;

    options = priorityOptions();

    priority = null;

    submit() {
        this.resolve({ priority: this.priority });

        this.hide();
    }

    beforeOpen(event) {
        this.priority = event?.params?.request?.priority ?? null;
    }

    beforeClose() {
        this.priority = null;
    }
}

export default VRequestChangePriorityModal;
</script>
